export class EventHandler<Event> {
    private _delegates: ((event: Event) => void)[] = [];

    get delegates() {
        return {
            add: (delegate: (event: Event) => void) => this._delegates.push(delegate),
            remove: (delegate: (event: Event) => void) => {
                const index = this._delegates.indexOf(delegate);

                if (index >= 0) {
                    this._delegates.splice(index, 1);
                }
            }
        };
    }

    update(event: Event) {
        this._delegates.forEach(delegate => delegate(event));
    }
}
